// API helpers — communicates with FastAPI backend for AI-driven word generation.
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 90_000,
  headers: { 'Content-Type': 'application/json' },
});

export async function generateWord(german, type = 'auto') {
  const { data } = await api.post('/words/generate', { german, type });
  return data;
}

export async function generateBatch(words) {
  const { data } = await api.post('/words/generate-batch', { words });
  return data;
}
